<div class="flex-1 container mx-auto px-4 py-12">
    <div class="max-w-4xl mx-auto">

        <h1 class="text-4xl md:text-5xl font-display font-bold mb-6">
            Engineering Log
        </h1>

        <p class="text-xl text-muted-foreground mb-12">
            Thoughts on AI, software architecture, and the future of technology.
        </p>

        <!-- LOADING -->
        <ng-container *ngIf="isLoading">
            <div class="flex justify-center py-20">
                <svg class="w-10 h-10 animate-spin text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10" opacity="0.25" />
                    <path d="M22 12a10 10 0 0 1-10 10" />
                </svg>
            </div>
        </ng-container>

        <!-- POSTS -->
        <ng-container *ngIf="!isLoading">
            <div class="space-y-12">

                <article *ngFor="let post of posts" class="group relative grid md:grid-cols-4 gap-6 items-start
                   border-b border-border/50 pb-12 last:border-0">
                    <!-- META -->
                    <div class="md:col-span-1 text-sm text-muted-foreground pt-2">
                        <div class="flex items-center gap-2 mb-2">
                            <span>📅</span>
                            <span>
                                {{ post.publishedAt ? (post.publishedAt | date) : 'Draft' }}
                            </span>
                        </div>

                        <div class="flex items-center gap-2">
                            <span>⏱</span>
                            <span>5 min read</span>
                        </div>
                    </div>

                    <!-- CONTENT -->
                    <div class="md:col-span-3 space-y-4">
                        <a [routerLink]="['/blog', post.slug]">
                            <h2 class="text-2xl font-display font-bold
                         group-hover:text-primary transition-colors cursor-pointer">
                                {{ post.title }}
                            </h2>
                        </a>

                        <div class="flex flex-wrap gap-2">
                            <app-badge *ngFor="let tag of post.tags" variant="outline" class="text-xs font-normal">
                                {{ tag }}
                            </app-badge>
                        </div>

                        <p class="text-muted-foreground leading-relaxed">
                            {{ post.summary }}
                        </p>

                        <a [routerLink]="['/blog', post.slug]" class="inline-flex items-center text-primary font-medium hover:underline mt-2">
                            Read Article →
                        </a>
                    </div>
                </article>

                <!-- EMPTY STATE -->
                <div *ngIf="posts.length === 0" class="text-center py-20 bg-secondary/20 rounded-2xl">
                    <p class="text-muted-foreground">
                        No posts published yet.
                    </p>
                </div>

            </div>
        </ng-container>
    </div>
</div>